export default {

  //GET FIRST LETTER OF A STRING TO UPPERCASE
  firstLetterUpper(item){
    if (item) {
      return item.substring(0,1).toUpperCase();
    }
    return null;
  },

  twoFirstLetterUpper(item){
    if (item) {
      return item.substring(0, 2).toUpperCase();
    }
    return null;
  },


  //GET FIRST LETTER OF A STRING TO LOWERCASE
  firstLetterlower(item){
    if (item) {
      return item.substring(0, 1).toLowercase();
    }
    return null;
  },

  //capitalizeFirstLetter
  capitalizeFirstLetter(string){
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
    return null;
  },

  //VALIDATED EMAIL
  validEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },

  //NUMBER OF WEEK BY YEAR
  getNumberOfWeek() {
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    const pastDaysOfYear = (today - firstDayOfYear) / 86400000;
    const result =  Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    return result;
  },

  //RETURN FIRST LETTER
  getFirstLetter(number){
    let res = number.charAt(0);
    if(res == '-'){
      return true
    }else if(res == '+'){
      return false
    }else {
      return null
    }
  },

  //RETURN STRING WITH FIRST LETTER IN UPPERCASE
  getCapitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },


  // RETURN TYPE OF CLASS  COMPARED TO THE FIRST LETTER
  getTheClass(target){
    const firstLetter = target.substring(0, 1);
    let theClass ='';
    switch (firstLetter){
      case '+':
      theClass = 'positif';
      break;
      case '-':
      theClass = 'negatif';
       break;
      case '=':
      theClass = 'equal';
       break;
    }
    return theClass;
  },


  getTheClassCompare(valueOne,valueTwo) {
    let result ='';
    if (Number(valueOne) < Number(valueTwo)){
      result = 'positif';
    }else if(Number(valueOne) > Number(valueTwo)){
      result = 'negatif';
    }else{
      result = 'equal';
    }
    return result;
  },

  //IS MOBILE
  isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
  },

  //COMPARE BETWEEN 2 NUMBERS
  compare(valueOne,valueTwo) {
    let result ='';
    if (Number(valueOne) < Number(valueTwo)){
      result = Number(valueTwo) - Number(valueOne);
    }else if(Number(valueOne) > Number(valueTwo)){
      result = Number(valueOne) - Number(valueTwo);
    }else{
      result = 0;
    }
    return result;
  },

  //COMPARE BETWEEN 2 NUMBERS
  compareBool(valueOne,valueTwo) {
    let result ='';
    if (Number(valueOne) < Number(valueTwo)){
      result = true;
    }else if(Number(valueOne) > Number(valueTwo)){
      result = false;
    }else{
      result = null;
    }
    return result;
  },

}
